<template>
  <div id="Wizualizacja">
    <div id="szafa">
      <div id="szafa-top" :style="BgImageTop('szafa/szafa_dso_' +iloscU+ '.svg')">
        <div id="grupa_otworow">
          <div class="wentylator"
          v-if="inputs.panel_wentylacyjny.value === '1' || inputs.panel_wentylacyjny.value === 1"
          :style="{top: '-20px', left: '0px' }"></div>

          <div id="szafa-elementy" style="width: 250px; position: absolute;">
            <div v-if="inputs.panel_wentylacyjny.value === '1' || inputs.panel_wentylacyjny.value === 1"
            class="zaslepka"
            :style="{top: '0px', left: '0px' }"></div>

            <div v-for="(wzm, index) in Number(inputs.wzmacniacz.value)"
            :key="index"
            class="wzmacniacz"
            :style="{top: topElementy(index) + 'px', left: '0px' }">
            {{$t('message.konfiguracja_wzmacniacz')}}</div>

            <div v-for="(wzm_rez, index) in Number(inputs.wzmacniacz_rezerwowy.value)"
            :key="index + Number(inputs.wzmacniacz.value)"
            class="wzmacniacz_rez"
            :style="{top: topElementy(index + Number(inputs.wzmacniacz.value)) + 'px', left: '0px' }">
            {{$t('message.konfiguracja_wzmacniacz_rez')}}</div>

            <div v-for="(kontrol, index) in Number(inputs.kontroler.value)"
            :key="index + Number(inputs.wzmacniacz.value) + Number(inputs.wzmacniacz_rezerwowy.value) + Number(inputs.router.value)"
            class="kontroler"
            :style="{top: topElementy(index + Number(inputs.wzmacniacz.value) + Number(inputs.wzmacniacz_rezerwowy.value)) + 'px', left: '0px' }">
            {{$t('message.konfiguracja_kontroler')}}</div>

            <div v-for="(rout, index) in Number(inputs.router.value)"
            :key="index + Number(inputs.wzmacniacz.value) + Number(inputs.wzmacniacz_rezerwowy.value)"
            class="router"
            :style="{top: topElementy(index + Number(inputs.wzmacniacz.value) + Number(inputs.wzmacniacz_rezerwowy.value) + Number(inputs.kontroler.value)) + 'px', left: '0px' }">
            {{$t('message.konfiguracja_router')}}</div>

            <div class="mikrofon" :style="{top: topMikrofon + 'px', left: '0px' }" v-if="inputs.wariant1.value > 0"></div>
            <div class="stale_elementy" :style="{top: topStaleElementy + 'px', left: '0px' }" v-if="heightAkumulator > 0">
              <div class="zasilacz" :style="{top: topZasilacz + 'px', left: '0px' }"></div>
              <div class="panel_sygnalizacyjny" :style="{top: (topPanel - 1) + 'px', left: '0px' }"></div>
              <div class="listwa" :style="[{top: topListwa + 'px', left: '0px' }, BgImageTop(getImgUrlListwa)]"></div>
              <div class="akumulator"
              :style="[{top: topAkumulator + 'px', left: '0px', height: heightAkumulator + 'px'},
                BgImageTop(getImgUrlAkum)]"></div>
            </div>
          </div>

          <div v-for="(pole,index) in Number(iloscU * 3)" :key="index"
          class="otwory_montazowe"><span v-if="Number.isInteger(Number(index) / 3)"
          style="font-size: 10px;
            height: 8px;
            line-height: 10px;
            position: absolute;
            margin-left: -15px;">
        {{iloscU - (index / 3)}}</span></div>
        </div>
      </div>
      <div id="szafa-bottom" :style="BgImageBottom(imgKolka)">
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { app } from '../mixins/app'
import { materials } from '../mixins/materials'
import { calculation } from '../mixins/calculation'

export default {
  name: '',
  mixins: [app, materials, calculation],
  data () {
    return {
      backgroundUrl: require('../assets/img/szafa/szafa_dso_24.svg')
    }
  },
  computed: {
    ...mapGetters('app', ['config']),
    ...mapGetters('app', ['outputs']),
    ...mapGetters('app', ['inputs']),
    ...mapGetters('products', ['ListaSzafy']),
    ...mapGetters('products', ['ListaAkcesoria']),
    ...mapGetters('products', ['ListaAkumulatory']),
    ...mapGetters('products', ['ListaZasilacze']),
    ...mapGetters('products', ['ListaListwyD']),
    ...mapGetters('products', ['ListaListwyZ']),
    ...mapGetters('products', ['ListaMaterialy']),

    getImgUrl () {
      var ilosc = (this.outputs.szafa.attributes.wysokosc === '') ? '24' : this.outputs.szafa.attributes.wysokosc
      return require('../assets/img/szafa/szafa_' + ilosc + '.png')
    },
    getImgUrlAkum () {
      var akumUrl = 'akumulator/akum_' + this.inputs.glebokosc_szafy.value + '_' + this.outputs.akumulator.pojemnosc + '.svg'
      return akumUrl
    },
    getImgUrlListwa () {
      var listwaZ = this.search_listwyZ(this.outputs.zasilacz.attributes.ciag, this.outputs.ilosc_faz.value)
      var listwaUrl = 'urzadzenia/listwa_' + listwaZ[0].gen_code + '.svg'
      return listwaUrl
    },
    iloscU () {
      return (this.outputs.szafa.attributes.wysokosc === '') ? '24' : this.outputs.szafa.attributes.wysokosc
    },
    imgKolka () {
      return (this.inputs.kolka.value === '1' || this.inputs.kolka.value === 1) ? 'dso_kolka.svg' : 'dso_cokol.svg'
    },
    topStaleElementy () {
      var wysokoscZasilacz = ((2 * 3) * 4.8 + ((2 * 3) - 1)) // 2U po 3 otw * wysokosc otworu
      var wysokoscPanel = ((1 * 3) * 4.8 + ((1 * 3) - 1))
      var wysokoscListwa = ((3 * 3) * 4.8 + ((3 * 3) - 1))
      var wysokoscAkumulatora = ((this.outputs.akumulator.wysokosc * 3) * 4.8 + ((this.outputs.akumulator.wysokosc * 3) - 1))
      var wysokoscSzafy = ((Number(this.outputs.szafa.attributes.wysokosc) * 3) * 4.8 + ((Number(this.outputs.szafa.attributes.wysokosc) * 3) - 1))
      var iloscPolek = this.outputs.akumulator.polki
      return (Number(wysokoscSzafy) - Number(wysokoscZasilacz + wysokoscPanel + wysokoscListwa + wysokoscAkumulatora) - (8 * iloscPolek))
    },
    topMikrofon () {
      var wysokoscStale = this.topStaleElementy
      return (wysokoscStale - ((5 * 3) * 4.8 + ((2 * 3))))
    },
    heightAkumulator () {
      var wysokoscAkumulatora = this.outputs.akumulator.wysokosc
      // var iloscPolek = this.outputs.akumulator.polki
      // return (wysokoscAkumulatora > 0) ? (wysokoscAkumulatora * 3) * 4.8 + ((wysokoscAkumulatora * 3) - 1) + 7 : 0
      return (wysokoscAkumulatora > 0) ? (wysokoscAkumulatora * 3) * 4.8 + ((wysokoscAkumulatora * 3) - 1) : 0
    },
    topAkumulator () {
      // var wysokoscAkumulatora = this.outputs.akumulator.wysokosc
      // var iloscPolek = this.outputs.akumulator.polki
      return 33.8 + 16.4 + 51.2 + 10 // (wysokoscAkumulatora > 0) ? (wysokoscAkumulatora * 3) * 4.8 + ((wysokoscAkumulatora * 3) - 1) : 0
    },
    topListwa () {
      // var wysokoscAkumulatora = this.topAkumulator - 51.2 // 51.2px - wysokosc listwy 3U
      return 59.2 // 33.8 + 16.4 + 10
    },
    topPanel () {
      // var wysokoscAkumulatora = 16.4// this.topAkumulator - 51.2 - 16.4 // 51.2px - wysokosc listwy 3U, 16.4 - panel 1U
      return 42.8 // 33.8 + 2
    },
    topZasilacz () {
      // this.topAkumulator - 51.2 - 16.4 - 33.8// 51.2px - wysokosc listwy 3U, 16.4 - panel 1U
      return 9
    }
  },
  methods: {
    BgImageTop (src) {
      // console.log(src)
      let bgImage = require('@/assets/img/' + src)
      return {
        backgroundImage: `url("${bgImage}")`
      }
    },
    BgImageBottom (src) {
      let bgImage = require('@/assets/img/urzadzenia/' + src)
      return {
        backgroundImage: `url("${bgImage}")`
      }
    },
    topElementy (index) {
      var dodatkowo = 0
      if (this.inputs.panel_wentylacyjny.value === '1' || this.inputs.panel_wentylacyjny.value === 1) {
        if (this.outputs.szafa.attributes.wysokosc > 24) {
          dodatkowo = 16.4
        } else {
          dodatkowo = 9.6
        }
      }
      return index * 39.6 + dodatkowo // 40.6
    }
  }
}
</script>

<style scoped>
#Wizualizacja {
  height: 100%;
}
#Wizualizacja img {
  width: 250px;
  position: absolute;
  bottom: 0px;
  left: 85px;
}
#szafa {
  width: 250px;
  height: 940px;
  position: absolute;
  left: 85px;
  bottom: 0px;
  bottom: -90px;
  transform: scale(0.8);
}
#szafa-top {
  width: 250px;
  height: 905px;
  /* background-image:  url("../assets/szafa_dso_24.svg"); */
}
#szafa-bottom {
  width: 250px;
  height: 35px;
  background-image:  url("../assets/img/urzadzenia/dso_cokol.svg");
}
#grupa_otworow {
  position:absolute; bottom:51px;left: 12px;
}
.otwory_montazowe {
  width:225px; height:4.8px; background:rgba(0,0,0,.1); margin-bottom:1px;
  text-align: left;
  position: relative;
}
.otwory_montazowe span{
  position: absolute;
  left: -12px;
  font-size: 10px;
}
.wentylator {
  width: 225px; height: 16.4px; background: rgb(0, 0, 0); position: absolute;
  background-image:  url("../assets/img/urzadzenia/wentylator.png");
  background-size: contain;
  text-align: left; padding: 0px 10px; color: white;
  z-index: 999;
}
.wzmacniacz {
  width: 225px; height: 33.8px; background: rgb(0, 0, 0); position: absolute;
  background-image:  url("../assets/img/urzadzenia/bg_bosch.png");
  background-size: contain;
  text-align: left; padding: 0px 10px; color: white;
  z-index: 999;
}
.wzmacniacz_rez {
  width: 225px; height: 33.8px; background: rgb(0, 0, 0); position: absolute;
  background-image:  url("../assets/img/urzadzenia/bg_bosch.png");
  background-size: contain;
  text-align: left; padding: 0px 10px; color: white;
  z-index: 999;
}
.router {
  width: 225px; height: 33.8px; background: rgb(0, 0, 0); position: absolute;
  background-image:  url("../assets/img/urzadzenia/bg_bosch.png");
  background-size: contain;
  text-align: left; padding: 0px 10px; color: white;
  z-index: 999;
}
.kontroler {
  width: 225px; height: 33.8px; background: rgb(0, 0, 0); position: absolute;
  background-image:  url("../assets/img/urzadzenia/bg_bosch.png");
  background-size: contain;
  text-align: left; padding: 0px 10px; color: white;
  z-index: 999;
}
.mikrofon {
  width: 225px; height: 86px; background: rgb(0, 0, 0); position: absolute;
  background-image:  url("../assets/img/urzadzenia/mikrofon.png");
  background-size: cover;
  text-align: left; padding: 0px 10px; color: white;
  z-index: 999;
}
.stale_elementy {
  width: 225px; position: absolute;
  text-align: left; padding: 0px 10px; color: white;
  left: 0px;
  }
.zasilacz {
  width: 225px; height: 33.8px; background: rgb(51, 51, 51); position: absolute;
  background-image:  url("../assets/img/urzadzenia/zasilacz.svg");
  background-size: contain;
  text-align: left; padding: 0px 10px; color: white;
  z-index: 999;
}
.panel_sygnalizacyjny {
  width: 225px; height: 16.4px; background: rgb(51, 51, 51); position: absolute;
  background-image:  url("../assets/img/urzadzenia/panel_sygnalizacyjny.svg");
  background-size: contain;
  text-align: left; padding: 0px 10px; color: white;
  z-index: 999;
}
.listwa {
  width: 225px; height: 51.2px; background: rgb(51, 51, 51); position: absolute;
  background-image:  url("../assets/img/urzadzenia/listwa.svg");
  background-size: contain;
  text-align: left; padding: 0px 10px; color: white;
  z-index: 999;
}
.akumulator {
  width: 225px; background: rgb(0, 0, 0); position: absolute;
  /* background-image:  url("../assets/img/urzadzenia/akum_600_35.svg"); */
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 999;
}
.zaslepka {
  width: 225px; height: 16.4px; background: rgb(51, 51, 51); position: absolute;
  background-image:  url("../assets/img/urzadzenia/zaslepka.svg");
  background-size: contain;
  text-align: left; padding: 0px 10px; color: white;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/components/Wizualizacja.vue